import {
  DeleteOutlined,
  EditOutlined,
  LockOutlined,
  PlusOutlined,
  SearchOutlined,
  UnlockOutlined
} from '@ant-design/icons'
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Empty,
  Form,
  Input,
  Row,
  Select,
  Space,
  Tabs,
  Tag,
  Tooltip
} from 'antd'
import { debounce } from 'lodash'
import get from 'lodash.get'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { roleInit } from '../../config-permission'
import { PAGE_SIZE_OPTIONS } from '../../configData'
import {
  deleteRole,
  departmentSearch,
  roleCreate,
  roleDetail,
  roleSearch,
  roleUpdate,
  updateStatus
} from '../../services/cmsservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import styles from './styles.module.scss'
import { v4 as uuidv4 } from 'uuid'
import { hasPermission, removeVietnameseTones } from '../../config-func'
import Loading from '../Loading';
const { Option } = Select
export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}
const layout = {
  // labelCol: {
  //   span: 11
  // },
  wrapperCol: {
    span: 24
  }
}

const newsFlowOptions = [
  { label: 'Tin bán', value: 'selling' },
  { label: 'Tin thuê', value: 'renting' },
  { label: 'Tìm mua', value: 'buying' },
  { label: 'Tìm thuê', value: 'leasing' }
]

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const { TabPane } = Tabs

const RoleManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const [listRole, setListRole] = useState([])
  const [listDepartment, setListDepartment] = useState([])
  const [checkedKeys, setCheckedKeys] = useState(new Set())
  const [loading, setLoading] = useState(false)
  const type = Form.useWatch('type', form) || 'APP' // Mặc định là APP
  const activeTabs = Form.useWatch('activeTabs', form) || {} // Lắng nghe checkbox của từng tab
  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10, // Số bản ghi mỗi trang
    reset: 0
  })

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    { title: 'Tên quyền', dataIndex: 'name', key: 'name', width: 150 },
    { title: 'Sàn', dataIndex: 'department_info', key: 'department_info',width: 150,render: (_, record) => <span>{record?.department_info?.name}</span> },
    {
      title: 'Loại quyền',
      dataIndex: 'type',
      key: 'type',
      width: 120,
    },
    // { title: 'Quản lý TP', dataIndex: 'name', key: 'name' },

    {
      title: 'Mô tả quyền',
      dataIndex: 'description',
      key: 'description',
      width: 150
    },
    // {
    //   title: 'Luồng tài khoản',
    //   dataIndex: 'description',
    //   key: 'description'
    // },
    {
      title: 'Trạng thái hoạt động',
      dataIndex: 'status',
      key: 'type',
      width: 150,
      render: (text) => {
        if (text === 'active') {
          return <Tag color="green">Hoạt động</Tag>
        } else if (text === 'inactive') {
          return <Tag color="red">Ngừng hoạt động</Tag>
        }
      }
    },
    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {/* <Tooltip title="Chỉnh sửa">
              <EditOutlined
                onClick={() => {
                  setMode(ACTION_MODE.UPDATE)
                  getDetailRole(record.id)
                }}
                style={{ fontSize: '16px', color: '#08c', cursor: 'pointer' }}
              />
            </Tooltip> */}
            {hasPermission('P40.2', permissions) && (
            <Tooltip title="Chỉnh sửa">
              <Button
                style={{ width: 32 }}
                icon={<EditOutlined />}
                onClick={() => {
                  setMode(ACTION_MODE.UPDATE)
                  getDetailRole(record.id)
                }}
              />
            </Tooltip>
            )}
            {/* {record.status !== 'inactive' && (
              <Tooltip title="Ngừng hoạt động">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận ngừng hoạt động Quyền',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn ngừng hoạt động quyền
                          <b> {record.name}</b> không?
                        </div>
                      ),
                      onOk: () => updateStatusRole(record)
                    })
                  }
                />
              </Tooltip>
            )} */}
            {hasPermission('P40.3', permissions) && (
            <Tooltip title={record.status == 'inactive' ? "Hoạt động" : "Ngừng hoạt động" }>
                    <Button
                      style={{ width: 32 }}
                      icon={record.status == 'inactive' ? <LockOutlined style={{color: 'red'}}/> : <UnlockOutlined style={{color: 'green'}}/>}
                      // icon={<LockOutlined />}
                      onClick={() =>
                        showConfirm({
                          title: `${
                            record.status == 'active' ? 'Ngừng hoạt động' : 'Hoạt động'
                          } quyền`,
                          content: (
                            <div>
                              Bạn có chắc chắn muốn{' '}
                              {record.status == 'active' ? 'Ngừng hoạt động' : 'Hoạt động'} quyển
                              <b> {record.name}</b> không?
                            </div>
                          ),
                          onOk: () =>
                            updateStatusRole(
                              record.status == 'inactive' ? 'active' : 'inactive',
                              record.id
                            )
                        })
                      }
                      // onClick={() => setVisibleChangePass(true)}
                    />
                  </Tooltip>
            )}
                  {hasPermission('P40.4', permissions) && (
                  <Tooltip title="Xóa quyền">
                    <Button
                      style={{ width: 32 }}
                      icon={<DeleteOutlined style={{ color: 'red' }} />}
                      onClick={() =>
                        showConfirm({
                          title: 'Xóa quyền',
                          content: (
                            <div>
                              Bạn có chắc chắn muốn xóa quyền
                              <b> {record.name}</b> không?
                            </div>
                          ),
                          type: 'error',
                          onOk: () => deleteRoleAction( record.id)
                          // onOk: () => deleteUser(record)
                        })
                      }
                    />
                  </Tooltip>
                  )}
          </Space>
        )
      }
    }
  ]
  const getPermissionAll = async (values) => {
    const {
      name = '',
      status = '',
      type = '',
      department_id = '',
      page = 1,
      pageSize = pagination.pageSize || 10
    } = values || {}
    setLoading(true)
    try {
      const body = {
        name: name.trim(),
        type,
        status,
        page,
        pageSize,
        department: department_id
      }

      const res = await roleSearch(body) // Assuming roleSearch is an API function

      if (res && res.data) {
        setListRole(res.data) // Update the state with the list of roles
      } else {
        // Handle the case where the response is unexpected or empty
        console.error('No data found or invalid response')
        setListRole([]) // Optionally, reset the list to an empty array
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
      setListRole([]) // Optionally, reset the list to an empty array
    } finally {
      setLoading(false)
    }
  }
  const getDepartmentAll = async () => {
    // const type = 'get_all'
    const type = ''
    const page = 1
    const pageSize = 1000
    const body = { type, page, pageSize }
    try {
      const res = await departmentSearch(body)
      setListDepartment(res.data)
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }

  useEffect(() => {
    getDepartmentAll()
  }, [])

  const handleCheck = (key, childs, parentKey) => {
    setCheckedKeys((prev) => {
      const newChecked = new Set(prev)
      const isChecked = !newChecked.has(key)

      if (isChecked) {
        // Nếu đang check
        newChecked.add(key)
        
        // Nếu có parent, thêm parent vào checkedKeys
        if (parentKey) {
          newChecked.add(parentKey)
        }
        
        // Nếu có childs, thêm tất cả childs vào checkedKeys
        if (childs) {
          const addAllChilds = (items) => {
            items.forEach((item) => {
              newChecked.add(item.key)
              if (item.childs) {
                addAllChilds(item.childs)
              }
            })
          }
          addAllChilds(childs)
        }
      } else {
        // Nếu đang uncheck
        newChecked.delete(key)
        
        // Nếu có childs, xóa tất cả childs khỏi checkedKeys
        if (childs) {
          const removeAllChilds = (items) => {
            items.forEach((item) => {
              newChecked.delete(item.key)
              if (item.childs) {
                removeAllChilds(item.childs)
              }
            })
          }
          removeAllChilds(childs)
        }
      }

      // Nếu có parent, kiểm tra và cập nhật trạng thái của parent
      if (parentKey) {
        const parent = findItemByKey(roleInit, parentKey)
        if (parent) {
          const allChildsChecked = parent.childs.every((child) =>
            newChecked.has(child.key)
          )
          const someChildsChecked = parent.childs.some((child) =>
            newChecked.has(child.key)
          )

          if (allChildsChecked && !newChecked.has(parentKey)) {
            newChecked.add(parentKey)
          } else if (!someChildsChecked && newChecked.has(parentKey)) {
            newChecked.delete(parentKey)
          }
        }
      }

      // Cập nhật form values
      updateFormValues(newChecked)

      return newChecked
    })
  }

  const updateFormValues = (newChecked) => {
    const values = {}
    Object.values(roleInit).forEach((app) => {
      const collectAllKeys = (node) => {
        values[node.key] = newChecked.has(node.key)
        if (node.childs) {
          node.childs.forEach(collectAllKeys)
        }
      }
      collectAllKeys(app)
    })
    form.setFieldsValue(values)
  }

  const findItemByKey = (data, key) => {
    for (const app of Object.values(data)) {
      const queue = [...(app.childs || [])]
      while (queue.length) {
        const node = queue.shift()
        if (node.key === key) return node
        if (node.childs) queue.push(...node.childs)
      }
    }
    return null
  }
  const isChecked = (key) => {
    return checkedKeys?.has(key)
  }

  const isIndeterminate = (key) => {
    const item = findItemByKey(roleInit, key)
    if (!item || !item.childs) return false

    const checkedChilds = item.childs.filter((child) =>
      checkedKeys?.has(child.key)
    )
    return checkedChilds.length > 0 && checkedChilds.length < item.childs.length
  }

  const renderCheckboxes = (items, parentKey = null) => {
    return items.map((item) => (
      <div
        key={`checkbox-container-${item.key}`}
        style={{ marginLeft: 10, padding: '2px 0' }}
      >
        <Form.Item
          name={item.key}
          valuePropName="checked"
          style={{ marginBottom: 0 }}
        >
          <Checkbox
            checked={isChecked(item.key)}
            indeterminate={isIndeterminate(item.key)}
            onChange={() => handleCheck(item.key, item.childs, parentKey)}
            key={`checkbox-${item.key}`}
          >
            {item.title}
          </Checkbox>
        </Form.Item>
        {item.childs && (
          <div key={`checkbox-children-${item.key}`} style={{ marginLeft: 20 }}>
            {renderCheckboxes(item.childs, item.key)}
          </div>
        )}
      </div>
    ))
  }

  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()

      // Lấy tất cả các key có giá trị true từ form
      const trueKeys = Object.entries(values)
        .filter(([key, value]) => value === true) // Lọc các giá trị true
        .map(([key]) => key) // Chỉ lấy key của các phần tử có giá trị true

      // Lấy tất cả các key từ checkedKeys (bao gồm cả các tab không active)
      const allCheckedKeys = Array.from(checkedKeys)

      // Kết hợp cả hai danh sách key và loại bỏ trùng lặp
      const finalPermissions = [...new Set([...trueKeys, ...allCheckedKeys])]

      const department_id = values.department_id || ''
      let body = {}
      if (department_id) {
        body = {
          name: values.name,
          department_id: department_id,
          type: values.type,
          description: values.description,
          permissions: finalPermissions
        }
      } else {
        body = {
          name: values.name,
          type: values.type,
          description: values.description,
          permissions: finalPermissions
        }
      }
      const res =
        mode == ACTION_MODE.ADD
          ? await roleCreate(body)
          : await roleUpdate(body, values.id)

      form.resetFields()
      setIsModalOpen(false)
      getPermissionAll()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo quyền thành công'
          : 'Cập nhật quyền thành công'
      )
      setCheckedKeys(new Set())
    } catch (err) {
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  const updateStatusRole = async (status, id) => {
    setLoading(true)
    try {
      const res = await updateStatus(status, id)
      getPermissionAll()
      openNotification('success', res.message)
    } catch (err) {
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const deleteRoleAction = async (id) => {
    setLoading(true)
    try {
      const res = await deleteRole(id)
      if(res?.data){
        getPermissionAll()
        openNotification('success', res.message)
      }else{
        openNotification('error', res.message)
      }
    } catch (err) {
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }
  const getDetailRole = async (id) => {
    setLoading(true)
    try {
      const res = await roleDetail(id)

      if (res && res.data) {
        setIsModalOpen(true)
        const values = res.data
        const permissionsArray = JSON.parse(values.permissions)

        // Tạo một đối tượng với các key từ mảng và giá trị là true
        const permissionsObj = permissionsArray.reduce((acc, permission) => {
          acc[permission] = true
          return acc
        }, {})

        // Kiểm tra quyền tương ứng với các role và set activeTabs
        const activeTabsObj = {}
        Object.entries(roleInit).forEach(([roleKey, role]) => {
          const hasAnyPermission = role.childs.some((child) => {
            const isChildChecked = permissionsObj[child.key]
            const hasAnyChildPermission = child.childs?.some(
              (grandChild) => permissionsObj[grandChild.key]
            )
            return isChildChecked || hasAnyChildPermission
          })

          if (hasAnyPermission) {
            activeTabsObj[roleKey] = true
          } else {
            activeTabsObj[roleKey] = false
          }
        })

        // Reset checkedKeys và set lại với permissions mới
        setCheckedKeys(new Set(permissionsArray))

        form.setFieldsValue({
          ...values,
          ...permissionsObj,
          activeTabs: activeTabsObj
        })
      } else {
        console.error('No data found or invalid response')
      }
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()

      getPermissionAll({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize, pagination.reset])

  // Khi thay đổi trang
  const handlePageChange = (current, pageSize) => {
    setPagination((prev) => ({
      ...prev,
      current: prev.pageSize !== pageSize ? 1 : current, // Nếu đổi pageSize thì reset current
      pageSize
    }))
  }

  const debouncedFormChange = useCallback(
    debounce(() => {
      const allValues = formSearch.getFieldsValue() // Lấy tất cả giá trị từ form
      getPermissionAll({
        ...allValues, // Truyền toàn bộ giá trị form
        page: 1, // Giữ nguyên trang hiện tại
        pageSize: pagination.pageSize // Giữ nguyên số lượng item mỗi trang
      })
    }, 300),
    [formSearch, pagination.current, pagination.pageSize]
  )
  // Form change handler with debounce
  // const handleFormChange = (changedValues, allValues) => {
  //   debouncedFormChange(changedValues, allValues)
  // }

  const handleReset = debounce( () => {
    // setFilters({currentPage: 1,
    // pageSize: 10})
    formSearch.resetFields()
    setPagination((prev) => ({
      current: 1, // Nếu đổi pageSize thì reset current
      pageSize: 10,
      reset: uuidv4()
    }))
  }, 300)

  // Thêm hàm mới để lấy tất cả các key của các checkbox con
  const getAllChildKeys = (node) => {
    const keys = [];
    
    // Hàm đệ quy để lấy tất cả các key
    const collectKeys = (item) => {
      keys.push(item.key);
      if (item.childs) {
        item.childs.forEach(collectKeys);
      }
    };
    
    // Bắt đầu từ các node con trực tiếp
    if (node.childs) {
      node.childs.forEach(collectKeys);
    }
    
    return keys;
  };

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <Form
          form={formSearch}
          layout="vertical"
          onFinish={debouncedFormChange}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              alignItems: 'center'
            }}
          >
            {/* Ô tìm kiếm */}

            <Form.Item
              labelCol={{ span: 8 }}
              label="Tên quyền"
              name="name"
              className={styles.formItem}
            >
              <Input
                prefix={<SearchOutlined />}
                placeholder="Nhập tên để tìm kiếm"
                onBlur={(e) => {
                  formSearch.setFields([
                    {
                      name: 'name',
                      value: e.target.value?.trim()
                    }
                  ])
                }}
              />
            </Form.Item>

            <Form.Item
              label="Loại quyền"
              name="type"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select placeholder="Chọn loại quyền"
              allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const inputValue = removeVietnameseTones(input).toLowerCase();
                    const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                    return optionValue.includes(inputValue);
                  }}
                  >
                <Option value="APP">APP</Option>
                <Option value="CMS">CMS</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="department_id"
              label="Sàn"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select
                placeholder="Chọn tên sàn"
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase();
                  const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                  return optionValue.includes(inputValue);
                }}
              >
                {listDepartment?.list?.map((item, idx) => {
                  return (
                    <Option key={idx} value={item.id}>
                      {item.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            {/* <Form.Item
              label="Luồng tin"
              name="newsFlow"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select defaultValue="">
                {newsFlowOptions.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item> */}
            <Form.Item
              label="Trạng thái"
              name="status"
              labelCol={{ span: 8 }}
              className={styles.formItem}
            >
              <Select allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const inputValue = removeVietnameseTones(input).toLowerCase();
                    const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                    return optionValue.includes(inputValue);
                  }}
                   placeholder="Chọn trạng thái">
                <Option value="active">Hoạt động</Option>
                <Option value="inactive">Ngừng hoạt động</Option>
              </Select>
            </Form.Item>
          </div>
          <div
            className={styles.formItem}
            style={{ textAlign: 'right', marginTop: 6 }}
          >
            <Button onClick={handleReset}>Đặt lại</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
            >
              Tìm kiếm
            </Button>
          </div>
        </Form>
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Danh sách quyền</h2> */}
          {hasPermission('P40.1', permissions) && (
          <Button
            type="primary"
            // htmlType="submit"
            onClick={() => {
              setIsModalOpen(true)
              setMode(ACTION_MODE.ADD)
            }}
          >
            <PlusOutlined />
              Thêm mới
            </Button>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          data={listRole?.list}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: listRole?.total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onChange: handlePageChange,
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`
            // onShowSizeChange: (current, size) => {
            //   setPageSize(size) // Cập nhật lại kích thước trang
            //   setCurrentPage(1) // Reset lại trang khi thay đổi kích thước trang
            // },

            // onChange: (page) => {
            //   setCurrentPage(page) // Cập nhật trang khi người dùng thay đổi trang
            //   // getPermissionAll({ page: page, pageSize: pageSize })
            // }
          }}
          rowKey={(record, index) => index}
          locale={{
            emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
            triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
            triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
            cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE ? 'Chỉnh sửa quyền' : 'Thêm mới quyền'
        }
        visible={isModalOpen}
        centered
        width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
          setCheckedKeys(new Set())
          //   setFileList([])
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <Form
          // variant={'filled'}
          // labelWrap
          requiredMark={customizeRequiredMark}
          labelAlign="left"
          form={form}
          layout="vertical"
          style={{
            // maxHeight: '80vh',
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '0px 10px'
          }}
          {...layout}
          initialValues={{
            type: 'CMS'
            // , activeTabs: { internal_app_r: true, cms: true }
          }}
        >
          <Form.Item name="id" label="" style={{ display: 'none' }}>
            <Input></Input>
          </Form.Item>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="department_id" label="Sàn">
                <Select
                  style={{ width: '100%' }}
                  placeholder="Chọn tên sàn"
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    const inputValue = removeVietnameseTones(input).toLowerCase();
                    const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                    return optionValue.includes(inputValue);
                  }}
                >
                  {listDepartment?.list?.map((item, idx) => {
                    return (
                      <Option key={idx} value={item.id}>
                        {item.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Tên quyền"
                name="name"
                rules={[
                  {
                    message: 'Vui lòng nhập tên quyền',
                    required: true
                  }
                ]}
              >
                <Input
                  placeholder="Nhập tên quyền"
                  onBlur={(e) => {
                    form.setFields([
                      {
                        name: 'name',
                        value: e.target.value?.trim()
                      }
                    ])
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Loại quyền"
                name="type"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng chọn loại quyền'
                  }
                ]}
              >
                <Select
                  disabled={mode == ACTION_MODE.UPDATE ? true : false}
                  placeholder="Chọn loại quyền"
                  defaultValue={'APP'}
                  onChange={() => {
                    setCheckedKeys(new Set())
                  }}
                >
                  <Option value="CMS">CMS</Option>
                  <Option value="APP">APP</Option>
                </Select>
              </Form.Item>
            </Col>
            {/* <Col span={8}>
              <Form.Item label="Luồng tin" name="shortName">
                <Select placeholder="Vui lòng chọn">
                  <Option value="all">Tất cả</Option>
                  <Option value="tin-ban">Tin bán</Option>
                  <Option value="tin-thue">Tin thuê</Option>
                  <Option value="tim-mua">Tìm mua</Option>
                  <Option value="tim-thue">Tìm thuê</Option>
                </Select>
              </Form.Item>
            </Col> */}
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item label="Mô tả" name="description">
                <Input
                  maxLength={1000}
                  placeholder="Nhập mô tả"
                  onBlur={(e) => {
                    form.setFields([
                      {
                        name: 'description',
                        value: e.target.value?.trim()
                      }
                    ])
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Divider orientation={'center'}>Phân Quyền</Divider>

          {/* <Tabs defaultActiveKey="internal_app" style={{ margin: '0 40px' }}>
            {Object.values(roleInit).map((app) => (
              <TabPane tab={app.title} key={app.key}>
                {app.childs && renderCheckboxes(app.childs)}
              </TabPane>
            ))}
          </Tabs> */}

          {/* Tabs với Checkbox */}
          <Tabs defaultActiveKey="internal_app" style={{ margin: '0 40px' }}>
            {Object.entries(
              type === 'CMS'
                ? { cms: roleInit.cms }
                : Object.fromEntries(
                    Object.entries(roleInit).filter(([key]) => key !== 'cms')
                  )
            ).map(([key, app]) => (
              <TabPane
                tab={
                  <div key={`tab-header-${key}`} style={{ display: 'flex', gap: 10 }}>
                    {app.title}
                    <Form.Item
                      name={['activeTabs', key]}
                      valuePropName="checked"
                      noStyle
                    >
                      <Checkbox 
                        key={`tab-checkbox-${key}`}
                        onChange={(e) => {
                          // Khi bỏ tích tab, bỏ tích tất cả các checkbox con
                          if (!e.target.checked) {
                            // Lấy tất cả các key của các checkbox con trong tab này
                            const childKeys = getAllChildKeys(app);
                            
                            // Cập nhật checkedKeys để bỏ tích tất cả các checkbox con
                            setCheckedKeys(prev => {
                              const newChecked = new Set(prev);
                              childKeys.forEach(childKey => {
                                newChecked.delete(childKey);
                              });
                              return newChecked;
                            });
                            
                            // Cập nhật form values
                            const formValues = {};
                            childKeys.forEach(childKey => {
                              formValues[childKey] = false;
                            });
                            form.setFieldsValue(formValues);
                          }
                        }}
                      />
                    </Form.Item>
                  </div>
                }
                key={`tab-pane-${key}`}
              >
                {activeTabs?.[key] && app.childs
                  ? renderCheckboxes(app.childs)
                  : null}
              </TabPane>
            ))}
          </Tabs>
          {/* Render Tabs dựa theo loại quyền đã chọn */}
          {/* <Tabs defaultActiveKey="internal_app" style={{ margin: '0 40px' }}>
            {Object.values(
              type === 'CMS'
                ? { cms: roleInit.cms } // Chỉ hiển thị CMS
                : Object.fromEntries(
                    Object.entries(roleInit).filter(([key]) => key !== 'cms')
                  ) // Hiển thị tất cả trừ CMS
            ).map((app) => (
              <TabPane tab={app.title} key={app.key}>
                {app.childs && renderCheckboxes(app.childs)}
              </TabPane>
            ))}
          </Tabs> */}
        </Form>
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default RoleManagement
